import colors from '@/assets/theme/colors/hex/index.common';
import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite/styled';
import View from '@/components/atomic/atoms/layout/view/styled';
import type { CtaProps } from '@/components/atomic/atoms/navigation/cta/typings.ts';
import styled, { CSSObject } from '@emotion/styled';

const Cta = styled(View)<CtaProps & { icon?: string }>(
	({ theme, $linkType, $hasIcon, $block, $maxWidth, icon }) => {
		const isBigIcon = typeof icon === 'string' && icon.endsWith('-big');

		let style: CSSObject = {
			position: 'relative',
			display: 'inline-flex',
			justifyContent: 'center',
			alignItems: 'center',
			flexDirection: 'row',
			gap: '12px',
			textAlign: 'center',
			width: $block ? '100%' : 'auto',
			maxWidth: $maxWidth,
		};

		let spanStyle: CSSObject = {
			fontSize: 10,
			fontWeight: 600,
			fontFamily: theme.font.families.secondary.demiBold,
			textUnderlineOffset: 2,
			textTransform: 'uppercase',
		};

		let svgStyle: CSSObject = {};

		let hoverStyle: CSSObject = {};

		let hoverSpanStyle: CSSObject = {};

		let hoverSvgStyle: CSSObject = {};

		switch ($linkType) {
			case 'primary':
				style = {
					...style,
					paddingTop: 13,
					paddingBottom: 13,
					paddingLeft: 20,
					paddingRight: 20,
					transition: 'background-color 0.3s ease',
					backgroundColor: theme.colors.primaryBrandColor,
					borderWidth: 1,
					borderStyle: 'solid',
					borderColor: theme.colors.primaryBrandColor,
				};
				hoverStyle = {
					...hoverStyle,
					backgroundColor: colors.white.hex(),
				};
				spanStyle = {
					...spanStyle,
					color: colors.white.hex(),
					transition: 'color 0.3s ease',
					lineHeight: '14px',
					letterSpacing: '3px',
				};
				hoverSpanStyle = {
					...hoverSpanStyle,
					color: theme.colors.primaryBrandColor,
				};
				svgStyle = {
					...svgStyle,
					width: 16,
					height: 16,
					left: 20,
					fill: colors.white.hex(),
					transition: 'fill 0.3s ease',
				};
				hoverSvgStyle = {
					...hoverSvgStyle,
					fill: theme.colors.primaryBrandColor,
				};
				break;
			case 'secondary':
				if ($hasIcon) {
					style = {
						...style,
						paddingLeft: 0,
						gap: isBigIcon ? '16px' : '7px',
					};
				}
				spanStyle = {
					...spanStyle,
					color: theme.colors.primaryBrandColor,
					lineHeight: '12.5px',
					letterSpacing: '2px',
					paddingBottom: '1px',
				};
				svgStyle = {
					...svgStyle,
					width: isBigIcon ? 18 : 11,
					height: isBigIcon ? 18 : 11,
					left: 0,
				};
				hoverSpanStyle = {
					textDecoration: 'underline',
				};
				break;
		}

		style = {
			...style,
			'&:hover': {
				...hoverStyle,
				span: hoverSpanStyle,
				[`${SvgSprite}`]: hoverSvgStyle,
			},
			span: spanStyle,
			[`${SvgSprite}`]: svgStyle,
		};

		return style;
	},
).withComponent('a');

export default Cta;
